import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  chinaPaymentsTitle: 'Now you can transfer to China!',
  chinaPaymentsDescription:
    'Pay your suppliers in CNY or USD using your MXN balance. Perform your international trade operations quickly and without complications! Start now!',
  chinaPaymentsCloseButton: 'Close',
  chinaPaymentsButton: 'Send Payment',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const CHINA_PAYMENT_LABELS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    chinaPaymentsTitle: '¡Ya puedes transferir a China!',
    chinaPaymentsDescription:
      'Paga a tus proveedores de China en CNY o USD usando tu balance de MXN. Realiza tus operaciones de comercio internacional de forma rápida y sin complicaciones ¡Empieza ahora!',
    chinaPaymentsCloseButton: 'Cerrar',
    chinaPaymentsButton: 'Enviar Pago',
  },
};

export default CHINA_PAYMENT_LABELS;
